import { render } from "./NotifUnsubscribe.vue?vue&type=template&id=67d9b6ac"
import script from "./NotifUnsubscribe.vue?vue&type=script&lang=ts"
export * from "./NotifUnsubscribe.vue?vue&type=script&lang=ts"
script.render = render

export default script